import { DOCUMENT, registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import { Component, Inject, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppRouteLogService, AppRouterService } from 'orv-ui-base-lib';

import { environment } from '../environments/environment';


@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {

	eventLoginCookie = 'ORVNewLogin';

	constructor(
		@Inject(DOCUMENT) private _document: HTMLDocument,
		// @Inject(LOCAL_STORAGE) private storage: StorageService,
		private translateService: TranslateService,
		private injector: Injector,
		private appRouteLogService: AppRouteLogService,
	) {
		this.translateService.addLangs(['en']);
		this.translateService.setDefaultLang('en');
		this.translateService.use('en');
		// register locale for pipe
		registerLocaleData(localeEn, 'en');
		// singleton instance of AppRouterService on startup
		this.injector.get(AppRouterService);

		// Change Favicon based on environment
		if (environment.commercial) {
			this._document.getElementById('appFavicon').setAttribute('href', 'assets/images/onroute-favicon.png');
		}

		// start route log service
		this.appRouteLogService.init();

		// this.sharedDataService.currentLoggedUser.subscribe(loggedUser => {
		// 	if (loggedUser) {
		// 		this.firebaseInit(loggedUser);
		// 	}
		// });

	}

	// firebaseInit(loggedUser: User) {
	// 	const firebaseConfig = {
	// 		apiKey: 'AIzaSyA34IHu00xFq6ySnD5dWG1UYA3DiXiCPi4',
	// 		authDomain: 'orv-analytics.firebaseapp.com',
	// 		projectId: 'orv-analytics',
	// 		storageBucket: 'orv-analytics.appspot.com',
	// 		messagingSenderId: '512695729657',
	// 		appId: '1:512695729657:web:52cccaaaa1b3f862109128',
	// 		measurementId: 'G-33H0LMF4LQ'
	// 	};
	// 	const app = initializeApp(firebaseConfig);
	// 	const analytics = getAnalytics(app);

	// 	this.router.events.subscribe(event => {
	// 		if (event instanceof NavigationEnd) {
	// 			logEvent(analytics, 'screen_view' as string, {
	// 				userid: loggedUser.id,
	// 				username: loggedUser.username,
	// 				idpassportno: loggedUser.idpassportno,
	// 				firebase_screen: event.url,
	// 				dev: !environment.production,
	// 			});
	// 		}

	// 		if (event instanceof NavigationStart && this.storage.has(this.eventLoginCookie)) {
	// 			logEvent(analytics, 'login' as string, {
	// 				userid: loggedUser.id,
	// 				username: loggedUser.username,
	// 				idpassportno: loggedUser.idpassportno,
	// 				datetime: JSON.parse(this.storage.get(this.eventLoginCookie)),
	// 				dev: !environment.production,
	// 			});
	// 			this.storage.remove(this.eventLoginCookie);
	// 		}
	// 	});
	// }
}
